import React, { useEffect, useState } from 'react';
import "./Terms_Conditions.css";
import Nav from '../LandingPage/Nav/Nav';
import Footer from '../LandingPage/Footer/Footer';
import { getwebsiteconfigs } from '../../Services/APIrequests'; // Adjust path if needed

function Terms_Conditions() {
  const [content, setContent] = useState('');

  const fetchTermsAndConditions = async () => {
    try {
      const response = await getwebsiteconfigs('Terms and Conditions');
      if (response?.data?.Status === 1) {
        const description = response?.data?.webSites?.description || '';
        setContent(description);
      }
    } catch (error) {
      console.error("Error fetching Terms & Conditions:", error);
    }
  };

  useEffect(() => {
    fetchTermsAndConditions();
  }, []);

  return (
    <div>
      <Nav />
      <div className='Terms_conditions'>
        <div>
          <h1 className='terms_Conditions_heading'>Terms & Conditions</h1>
          <div
            className="terms_Conditions_content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Terms_Conditions;
